export enum AnimationPanelType {
  DEFAULT = 'default',
  INTRO_ANIMATION_STYLES = 'intro-animation-styles',
  OUTRO_ANIMATION_STYLES = 'outro-animation-styles',
}

export enum AnimationTabType {
  ENTRANCE = 'entrance',
  EXIT = 'exit',
  BOTH = 'both',
}

export enum PreviewType {
  DESIGN = 'design',
  TEXT = 'text',
  MEDIA = 'media',
  ELEMENT = 'element',
}
